import { put, takeEvery } from 'redux-saga/effects';
import {
  deleteRoleSuccess,
  deleteRoleFailure,
} from 'redux/ums-user-management/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import UmsUserManagementActionTypes from '../types';
import { SUCCESS, TOP_RIGHT } from 'utils/constants';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

export function* deleteRole({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/ums/roles/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });

  if (response.success) {
    yield put(deleteRoleSuccess(id));
    Notify(`Role deleted successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Delete Role: ${response.message}`);
    yield put(deleteRoleFailure(response.message));
  }
}

export function* onDeleteRole() {
  yield takeEvery(
    UmsUserManagementActionTypes.DELETE_ROLE_START,
    deleteRole
  );
}
